export const DEFAULT_LOCALE = "en-US";

export const HOMEPAGE_MESSAGE_BUNDLE_NAME = "pages.homepage";

export const ROUTES = {
    API_ONBOARDING: "/apiOnboarding",
    SERVICE_ONBOARDING: "/serviceOnboarding",
}

export const LOOM_ACCESS_TOKEN ="loom.authenticated.access"

export const RESOURCE_REGEX_PATTERN = /^([a-zA-Z0-9_-]+|\{[a-zA-Z0-9_]+\})(\/([a-zA-Z0-9_-]+|\{[a-zA-Z0-9_]+\}))*$/;

export const AAA_IDENTIFIER_PATTERN = /^https:\/\/aaa\.amazon\.com\/scopes\/[A-Za-z0-9]+#[A-Za-z0-9]+$/;

export const REGION = "IAD";

export const INFRA_DEPLOYMENT_TYPE = "EC2_SERVICE_BEHIND_FARGATE";

export const CLIENT_TYPE = "ds2lime";